var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iconly/Light-Outline/Paper Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Paper-Plus",
    stroke: "none",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper-Plus",
    transform: "translate(3.000000, 2.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9745,0.0004 C11.017449,0.0004 11.0595585,0.00401613217 11.1005405,0.0109603403 L11.2369,0.0117 C11.4409,0.0117 11.6359,0.0947 11.7779,0.2417 L16.8439,5.5207 C16.9769,5.6597 17.051906,5.8467 17.051906,6.0397 L17.051906,15.3397 C17.0559,17.8087 15.0499,19.8397 12.5809,19.8657 L4.3999,19.8667 C1.9269,19.8237 -0.0411,17.7867 0.000899999999,15.3267 L0.000899999999,4.4907 C0.0579,2.0097 2.1069,0.0117 4.5699,0.0117 L10.8484595,0.0109603403 C10.8894415,0.00401613217 10.931551,0.0004 10.9745,0.0004 Z M10.2242401,1.5114 L4.5729,1.5117 C2.9149,1.5117 1.5399,2.8537 1.5009,4.5087 L1.5009,15.3397 C1.4719,16.9867 2.7789,18.3387 4.4139,18.3667 L4.5609,18.3657 L12.5729,18.3657 C14.2149,18.3477 15.5539,16.9907 15.5519022,15.3407 L15.5512401,6.9834 L13.5435,6.9844 C11.7125,6.9794 10.2245,5.4874 10.2245,3.6594 L10.2242401,1.5114 Z M8.3444,7.7143 C8.7584,7.7143 9.0944,8.0503 9.0944,8.4643 L9.09424006,10.1634 L10.7936,10.1641 C11.2076,10.1641 11.5436,10.5001 11.5436,10.9141 C11.5436,11.3281 11.2076,11.6641 10.7936,11.6641 L9.09424006,11.6634 L9.0944,13.3643 C9.0944,13.7783 8.7584,14.1143 8.3444,14.1143 C7.9304,14.1143 7.5944,13.7783 7.5944,13.3643 L7.59424006,11.6634 L5.8946,11.6641 C5.4806,11.6641 5.1446,11.3281 5.1446,10.9141 C5.1446,10.5001 5.4806,10.1641 5.8946,10.1641 L7.59424006,10.1634 L7.5944,8.4643 C7.5944,8.0503 7.9304,7.7143 8.3444,7.7143 Z M11.7242401,2.3524 L11.7245,3.6594 C11.7245,4.6634 12.5415,5.4814 13.5455,5.4844 L14.7282401,5.4834 L11.7242401,2.3524 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlusIcon);
export default __webpack_public_path__ + "static/media/paper-plus-icon.6ac696bc849b3dc1f3c68874e216a9fb.svg";
export { ForwardRef as ReactComponent };